import React, { PureComponent, Fragment } from 'react';
import { removeLayer } from '@ro-utils/common/helpers';
import { textMarker } from '@ro-utils/common/map/textmarker';
import { asString } from '@ro-utils/common/helpers';

import { LAYER_SYNOP } from '@ro-utils/constant';

class WeatherStations extends PureComponent {
  setData(props) {
    const { data, map, index } = props;
    map && removeLayer(LAYER_SYNOP, map);

    map &&
      data &&
      textMarker({
        item: data,
        type: props.type,
        offset: 0,
        uitype: LAYER_SYNOP,
        layerIndex: index
      });
  }
  componentDidMount() {
    this.setData(this.props);
  }
  componentWillReceiveProps(nextProps) {
    if (asString(nextProps.data) !== asString(this.props.data) || nextProps.type !== this.props.type) {
      this.setData(nextProps);
    }
  }
  render() {
    return <Fragment />;
  }
}

export default WeatherStations;
